import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { defaultUserRoute } from '../config/routes.config';
import { getErpActive } from '../services/storage.service';
// tslint:disable-next-line: max-line-length
import { isAppToolManagementHistoricalPrivilege, isAppToolManagementOrderRequestPrivilege, isAppToolManagementPendingOrdersPrivilege, isAppToolManagementSendErpPrivilege, isAppToolManagementToolPrivilege, isAppToolManagementValidateReconstructionPrivilege, isSAPrivilege } from '../utils/jwt.utils';

@Injectable()
export class ToolManagementGuard implements CanActivate, CanLoad {
  constructor(
    private router: Router
  ) { }

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.checkAccess();
  }

  canLoad(
    _route: Route
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.checkAccess();
  }

  private checkAccess() {
    if (
      (isAppToolManagementToolPrivilege() ||
      isAppToolManagementOrderRequestPrivilege() ||
      isAppToolManagementPendingOrdersPrivilege() ||
      isAppToolManagementValidateReconstructionPrivilege() ||
      isAppToolManagementSendErpPrivilege() ||
      isAppToolManagementHistoricalPrivilege() ||
      isSAPrivilege()
      ) && getErpActive()) {
      return true;
    } else {
      this.router.navigateByUrl(defaultUserRoute);
      return false;
    }
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/guards/tool-management.guard.ts